module.exports = __webpack_public_path__ + "static/media/rocket.b9279452.png";